import React, { useContext } from 'react';

import Count from '@totem/components/common/Count';
import AnalysisContext from '@totem/components/surveyV2/analysis/AnalysisContext';
import SubTitle from '@totem/components/surveyV2/SubTitle';
import colors from '@totem/styles/colors';
import { isNull } from '@totem/utilities/common';

import '../survey.css';

const styles = {
  completedAuditsCounts: {
    background: colors.neutral.white,
    border: `2px solid ${colors.antd.blue}`,
    marginTop: '1rem',
    marginRight: '1rem',
    minWidth: '8rem',
  },
};

const PolicyResponses = () => {
  const { data } = useContext(AnalysisContext);

  return (
    <div styleName="overview-section">
      <SubTitle>Policy Responses</SubTitle>
      <div styleName="overview-content">
        <div styleName="overview-content-container">
          <div styleName="graph-title">Total Completed Audits</div>
          <div styleName="completed-audits-content">
            <Count
              count={isNull(data) ? 0 : data.totalAudits}
              size="large"
              style={styles.completedAuditsCounts}
            />
            {/*<div styleName="graph-title no-bold">{`${*/}
            {/*  data.totalAudits*/}
            {/*} complete out of ${completionCounts.complete +*/}
            {/*completionCounts.inProgress} in progress`}</div>*/}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PolicyResponses;
